import { Box, Grid2, Typography, useTheme } from "@mui/material";
import { green, grey, red, yellow, orange } from "@mui/material/colors";

import { DisplayStatus, displayStatus } from "api";
import { getLiveData, getSelectedPowerPlant, useAppSelector } from "store";

import { LiveData } from "./components";

export const Navbar = ({ belowStatus }: { belowStatus: boolean }) => {
  const theme = useTheme();
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const liveData = useAppSelector(getLiveData);

  const status = displayStatus(selectedPowerPlant, liveData);
  const statusColorMap: Record<DisplayStatus, string> = {
    producing: green[600],
    consuming: yellow[600],
    idle: grey[600],
    offline: red[600],
    noReading: orange[600],
    stale: grey[400],
  };

  return (
    <Grid2
      container
      direction={"column"}
      className={`${theme.palette.mode === "dark" ? "bg-black/70" : "bg-white/70"} backdrop-blur gap-y-2 transition-all duration-300`}
      position={"fixed"}
      top={0}
      pt={belowStatus ? 2 : 6}
      pb={belowStatus ? 2 : 0}
      zIndex={1000}
      width={"100%"}
    >
      <Grid2
        container
        direction={"column"}
        spacing={0}
        alignItems={"center"}
        width={"100%"}
        sx={{
          transform: "translateX(8px)",
        }}
      >
        <Grid2
          container
          gap={2}
          sx={{
            alignItems: "center",
          }}
        >
          <Typography
            align="center"
            variant="h5"
            component="div"
            color="primary"
            fontSize={22}
            fontWeight={900}
          >
            {selectedPowerPlant?.name || "Power Plant"}
          </Typography>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: 2,
              backgroundColor: statusColorMap[status],
              visibility: belowStatus ? "visible" : "hidden",
            }}
          />
        </Grid2>
      </Grid2>
      <LiveData />
    </Grid2>
  );
};
